import { render, staticRenderFns } from "./DoughnutChartError.vue?vue&type=template&id=a2596212&scoped=true"
import script from "./DoughnutChartError.vue?vue&type=script&lang=js"
export * from "./DoughnutChartError.vue?vue&type=script&lang=js"
import style0 from "./DoughnutChartError.vue?vue&type=style&index=0&id=a2596212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2596212",
  null
  
)

export default component.exports